import {
  IberiaCardsCampaign,
  IberiaCardsCampaignGroup,
  IberiaCardsCampaignGroupValue,
} from '@/components/modules/Application/IberiaCards/_shared/types/IberiaCardsCampaign';

const GROUP_ORDER = Object.values(IberiaCardsCampaignGroup);

export class CampaignGroupMap {
  // Stable, so campaigns keep their listed order inside each group
  public static sortByGroup(campaigns: IberiaCardsCampaign[]): IberiaCardsCampaign[] {
    return [...campaigns].sort((a, b) => GROUP_ORDER.indexOf(a.group) - GROUP_ORDER.indexOf(b.group));
  }

  public static toTextId(group: IberiaCardsCampaignGroupValue): string {
    return `IBERIA_CARDS_CAMPAIGN_GROUP_${group}`;
  }
}
